import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Media } from '../../..';
import { Container } from '../../Components/Container';
import { mobileSubmitSectionItemsStyles, MobileSubmitSectionWrapper } from './styled';
export const MobileSubmitSection = (props) => {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const itemsStyles = useMemo(() => [mobileSubmitSectionItemsStyles, props.itemsStyles].filter(Boolean).join(' '), [props.itemsStyles]);
    if (!isMobile) {
        return null;
    }
    return (_jsx(Container, { children: _jsx(MobileSubmitSectionWrapper, { ...props, itemsStyles: itemsStyles }) }));
};
